const modalStyle = `
position: fixed;
top: 0;
left: 0;
height: 100%;
width: 100%;
z-index: 999999;`;

export const inactive = `
#modal {
  ${modalStyle}
}
`;
export const active = `
#modal {
  ${modalStyle}
}
`;
